<template>
  <div>
    <StandardCard
      :title="!loading ? `Ordre #${value.orderId}` : 'Ordre #'"
      subheader="INFO"
    >
      <template v-slot>
        <div v-if="loading" class="text-center pb-4">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div v-else>
          <CardContent v-model="data" />
        </div>
      </template>
    </StandardCard>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";

import StandardCard from "@/components/shared/cards/StandardCard.vue";
import CardContent from "@/components/shared/cards/children/CardContent.vue";

export default Vue.extend({
  name: "ComplaintInfoCard",
  props: {
    value: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editProfile: false,
    };
  },
  computed: {
    data() {
      var profileItems = [
        {
          icon: "mdi-home-city-outline",
          title: "Prosjekt",
          content: this.value.project,
        },
        {
          icon: "mdi-home-outline",
          title: "Bygg",
          content: this.value.phase,
        },
        {
          icon: "mdi-map-marker-outline",
          title: "Leveringsadresse",
          content: this.value.deliveryAddress,
        },
        {
          icon: "mdi-clipboard-edit-outline",
          title: "Aktivitet",
          content: this.value.process,
        },

        {
          icon: "mdi-office-building-outline",
          title: "Leverandør",
          content: this.value.contactName,
        },
        {
          icon: "mdi-calendar",
          title: "Ordredato",
          content: this.value.orderDate
            ? moment(this.value.orderDate).format("DD.MM.YYYY")
            : "",
        },
        {
          icon: "mdi-truck-delivery-outline",
          title: "Leveringsdato",
          content: this.value.deliveryDate
            ? moment(this.value.deliveryDate).format("DD.MM.YYYY")
            : "",
        },
        {
          icon: "mdi-account-hard-hat-outline",
          title: "Byggeplass kontakt",
          content: this.value.contactPerson,
        },
        {
          icon: "mdi-account-outline",
          title: "Vår kontakt",
          content: this.value.ourReference,
        },
        {
          icon: "mdi-clipboard-edit-outline",
          title: "Merknad",
          content: this.value.txt,
        },
      ];

      return profileItems;
    },
  },
  components: {
    StandardCard,
    CardContent,
  },
});
</script>
